import {
    Box,
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Menu,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Typography,
    useMediaQuery,
    useTheme,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { Add, Clear, Delete, Edit, MoreVert, Search, Settings } from "@material-ui/icons"
import { useSnackbar } from "../../utils/notificacoes"
import { useEffect, useState } from "react"
import { deletarParametro, obterParametrosGerais, salvarParametro } from "../../services/parametros"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"
import Cabecalho from "../Cabecalho"

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: "4.1rem",
        paddingLeft: "5.2rem",
        width: "1500px",
        margin: "auto",
        marginBottom: "2rem",
        [theme.breakpoints.down("sm")]: {
            width: "100vw",
            paddingTop: "0",
            paddingInline: "0.8rem",
        },
    },

    content: {
        paddingTop: "1.5rem",
    },

    header: {
        marginBottom: "1.5rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
        [theme.breakpoints.down("sm")]: {
            marginTop: "4rem",
            flexDirection: "column",
            alignItems: "flex-start",
        },
    },

    tableContainer: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        backgroundColor: "white",
        overflow: "hidden",
    },

    tableScroll: {
        overflowX: "auto",
    },

    tableHeader: {
        backgroundColor: "#f8f9fa",
        "& .MuiTableCell-head": {
            fontWeight: 600,
            color: "#2c3e50",
            borderBottom: "2px solid #e9ecef",
        },
    },

    tableRow: {
        transition: "all 0.2s ease",
        "&:hover": { backgroundColor: "#f8f9fa" },
        "& .MuiTableCell-root": {
            borderBottom: "1px solid #f1f3f4",
            padding: "1rem",
        },
    },

    searchContainer: {
        marginBottom: "1.5rem",
        display: "flex",
        gap: "1rem",
        alignItems: "center",
        flexWrap: "wrap",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "stretch",
            gap: "0.75rem",
        },
    },

    searchField: {
        backgroundColor: "white",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        flex: 1,
        "& .MuiOutlinedInput-root": {
            borderRadius: 25,
            "& fieldset": { border: "none !important" },
            "&:hover fieldset": { border: "none !important" },
            "&.Mui-focused fieldset": { border: "none !important" },
        },
    },

    actionsRow: {
        display: "flex",
        gap: "1rem",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            flexDirection: "column",
            gap: "0.75rem",
        },
    },

    addButton: {
        borderRadius: 25,
        backgroundColor: "#4caf50",
        color: "white",
        padding: "0.75rem 1.5rem",
        fontWeight: 600,
        boxShadow: "0 4px 15px rgba(76, 175, 80, 0.3)",
        whiteSpace: "nowrap",
        [theme.breakpoints.down("sm")]: { width: "100%" },
        "&:hover": {
            backgroundColor: "#45a049",
            transform: "translateY(-2px)",
            boxShadow: "0 6px 20px rgba(76, 175, 80, 0.4)",
        },
    },

    emptyState: {
        textAlign: "center",
        padding: "4rem",
        color: "#95a5a6",
    },

    paginationContainer: {
        backgroundColor: "white",
        borderTop: "1px solid #f1f3f4",
        marginBottom: "0.5rem",
    },

    mobileCard: {
        borderRadius: 16,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        padding: "1rem",
        backgroundColor: "white",
    },

    mobileCardRow: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "0.5rem",
    },

    mobileLabel: {
        color: "#95a5a6",
    },

    formField: {
        marginBottom: "1rem",
        "& .MuiOutlinedInput-root": { borderRadius: 15 },
    },

    dialogContent: { padding: "1.5rem" },
}))

export function TelaParametros() {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const setLoading = useLoadingStore(s => s.setLoading)
    const autorizacao = localStorage.getItem("chaveSistema")
    const { enqueueSnackbar } = useSnackbar()
    const configuracoes = useAppStore(s => s.configuracoes)
    const idEstabelecimento = configuracoes.user.parametros.estabelecimento.id

    const alertStart = (msg, tipo) => enqueueSnackbar(msg, { variant: tipo })

    const [parametrosGerais, setParametrosGerais] = useState([])
    const [busca, setBusca] = useState("")
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [anchorEl, setAnchorEl] = useState(null)
    const [selectedRow, setSelectedRow] = useState(null)
    const [openDialog, setOpenDialog] = useState(false)
    const [editando, setEditando] = useState(null)
    const [nome, setNome] = useState("")
    const [valor, setValor] = useState("")
    const [publico, setPublico] = useState(false)
    const [openDialogExcluir, setOpenDialogExcluir] = useState(false)
    const [idParaExcluir, setIdParaExcluir] = useState(null)

    const handleBuscarParametros = async () => {
        try {
            setLoading(true)
            const response = await obterParametrosGerais(idEstabelecimento, autorizacao)
            if (response.retornoErro) {
                alertStart("Erro ao obter parâmetros gerais", "error")
            } else {
                setParametrosGerais(response)
            }
        } catch {
            alertStart("Erro ao obter parâmetros gerais", "error")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        handleBuscarParametros()
    }, [])

    const parametrosFiltrados = (parametrosGerais || []).filter(
        p =>
            p.nome?.toLowerCase().includes(busca.toLowerCase()) ||
            p.valor?.toLowerCase().includes(busca.toLowerCase())
    )

    const paginatedRows = parametrosFiltrados.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    )

    const handleMenuOpen = (event, row) => {
        setAnchorEl(event.currentTarget)
        setSelectedRow(row)
    }

    const handleMenuClose = () => {
        setAnchorEl(null)
        setSelectedRow(null)
    }

    const abrirDialogNovo = () => {
        setEditando(null)
        setNome("")
        setValor("")
        setPublico(false)
        setOpenDialog(true)
    }

    const abrirDialogEditar = row => {
        setEditando(row)
        setNome(row.nome || "")
        setValor(row.valor || "")
        setPublico(row.publico || false)
        setOpenDialog(true)
        handleMenuClose()
    }

    const salvar = async () => {
        if (!nome.trim()) {
            alertStart("Nome é obrigatório", "error")
            return
        }

        setLoading(true)
        try {
            const dados = { nome, valor, publico }
            if (editando?.id) dados.id = editando.id

            const response = await salvarParametro(idEstabelecimento, dados, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return
            }

            if (editando?.id) {
                setParametrosGerais(prev =>
                    prev.map(p => (p.id === editando.id ? { ...p, nome, valor, publico } : p))
                )
                alertStart("Parâmetro atualizado com sucesso", "success")
            } else {
                setParametrosGerais(prev => [...prev, response])
                alertStart("Parâmetro criado com sucesso", "success")
            }

            setOpenDialog(false)
        } catch {
            alertStart("Erro ao salvar parâmetro", "error")
        } finally {
            setLoading(false)
        }
    }

    const confirmarExclusao = async () => {
        setLoading(true)
        try {
            const response = await deletarParametro(idEstabelecimento, idParaExcluir, autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return
            }

            setParametrosGerais(prev => prev.filter(p => p.id !== idParaExcluir))
            setPage(prevPage => {
                const total = (parametrosGerais?.length || 0) - 1
                const ultima = Math.max(0, Math.ceil(total / rowsPerPage) - 1)
                return prevPage > ultima ? ultima : prevPage
            })
            alertStart("Parâmetro excluído com sucesso", "success")
        } catch {
            alertStart("Erro ao excluir parâmetro", "error")
        } finally {
            setLoading(false)
            setOpenDialogExcluir(false)
        }
    }

    const excluir = row => {
        setIdParaExcluir(row.id)
        setOpenDialogExcluir(true)
        handleMenuClose()
    }

    return (
        <div>
            <Cabecalho pagina="Parâmetros Gerais" />
            <div className={classes.root}>
                <Box className={classes.content}>
                    <Box className={classes.header}>
                        <Box display="flex" alignItems="center" style={{ gap: 12, flexWrap: "wrap" }}>
                            <Typography variant="h4" style={{ fontWeight: 600, color: "#2c3e50" }}>
                                Parâmetros Gerais
                            </Typography>
                            <Chip
                                size="small"
                                label="Uso exclusivo do perfil CLIENTEFIEL"
                                style={{ backgroundColor: "#1976d2", color: "white", fontWeight: 600 }}
                            />
                        </Box>
                        <Typography variant="subtitle1" style={{ color: "#7f8c8d" }}>
                            {parametrosGerais?.length || 0} parâmetros cadastrados
                        </Typography>
                    </Box>

                    <Box className={classes.searchContainer}>
                        <TextField
                            className={classes.searchField}
                            placeholder="Buscar parâmetros por nome ou valor..."
                            variant="outlined"
                            size="small"
                            value={busca}
                            onChange={e => {
                                setBusca(e.target.value)
                                setPage(0)
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search style={{ color: "#95a5a6" }} />
                                    </InputAdornment>
                                ),
                                endAdornment: busca && (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={() => setBusca("")}>
                                            <Clear fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Box className={classes.actionsRow}>
                            <Button
                                className={classes.addButton}
                                startIcon={<Add />}
                                onClick={abrirDialogNovo}
                            >
                                Novo Parâmetro
                            </Button>
                        </Box>
                    </Box>

                    {parametrosFiltrados.length > 0 ? (
                        isMobile ? (
                            <Box display="grid" gridGap={16}>
                                {paginatedRows.map(row => (
                                    <Paper key={row.id} className={classes.mobileCard}>
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="flex-start"
                                            gridGap={12}
                                        >
                                            <Box minWidth={0} flex={1}>
                                                <Typography
                                                    variant="subtitle1"
                                                    style={{
                                                        fontWeight: 700,
                                                        color: "#2c3e50",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        maxWidth: "280px",
                                                    }}
                                                    title={row.nome}
                                                >
                                                    {row.nome}
                                                </Typography>
                                            </Box>
                                            <IconButton
                                                size="small"
                                                onClick={e => handleMenuOpen(e, row)}
                                            >
                                                <MoreVert />
                                            </IconButton>
                                        </Box>

                                        <Box className={classes.mobileCardRow}>
                                            <Typography
                                                variant="body2"
                                                className={classes.mobileLabel}
                                            >
                                                Valor
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                style={{
                                                    color: "#7f8c8d",
                                                    maxWidth: 250,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {row.valor || "-"}
                                            </Typography>
                                        </Box>

                                        <Box className={classes.mobileCardRow}>
                                            <Typography
                                                variant="body2"
                                                className={classes.mobileLabel}
                                            >
                                                Visível para o site
                                            </Typography>
                                            <Chip
                                                label={row.publico ? "Sim" : "Não"}
                                                size="small"
                                                style={{
                                                    borderRadius: 12,
                                                    backgroundColor: row.publico
                                                        ? "#e8f5e9"
                                                        : "#fce4ec",
                                                    color: row.publico ? "#2e7d32" : "#c62828",
                                                    fontWeight: 600,
                                                }}
                                            />
                                        </Box>
                                    </Paper>
                                ))}

                                <Paper className={classes.paginationContainer}>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={parametrosFiltrados.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={(_, newPage) => setPage(newPage)}
                                        onRowsPerPageChange={e => {
                                            setRowsPerPage(+e.target.value)
                                            setPage(0)
                                        }}
                                        labelRowsPerPage="Itens"
                                    />
                                </Paper>
                            </Box>
                        ) : (
                            <Paper className={classes.tableContainer}>
                                <TableContainer className={classes.tableScroll}>
                                    <Table style={{ minWidth: 700 }}>
                                        <TableHead className={classes.tableHeader}>
                                            <TableRow>
                                                <TableCell style={{ width: "35%" }}>Nome</TableCell>
                                                <TableCell style={{ width: "40%" }}>
                                                    Valor
                                                </TableCell>
                                                <TableCell style={{ width: "15%" }} align="center">
                                                    Visível para o site
                                                </TableCell>
                                                <TableCell style={{ width: "10%" }} align="center">
                                                    Ações
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {paginatedRows.map(row => (
                                                <TableRow key={row.id} className={classes.tableRow}>
                                                    <TableCell>
                                                        <Typography
                                                            variant="subtitle1"
                                                            style={{
                                                                fontWeight: 600,
                                                                color: "#2c3e50",
                                                                maxWidth: 450,
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                cursor: "default",
                                                            }}
                                                            title={row.nome}
                                                        >
                                                            {row.nome}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography
                                                            variant="body2"
                                                            style={{
                                                                color: "#7f8c8d",
                                                                maxWidth: 400,
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {row.valor || "-"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Chip
                                                            label={row.publico ? "Sim" : "Não"}
                                                            size="small"
                                                            style={{
                                                                borderRadius: 12,
                                                                backgroundColor: row.publico
                                                                    ? "#e8f5e9"
                                                                    : "#fce4ec",
                                                                color: row.publico
                                                                    ? "#2e7d32"
                                                                    : "#c62828",
                                                                fontWeight: 600,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <IconButton
                                                            size="small"
                                                            onClick={e => handleMenuOpen(e, row)}
                                                        >
                                                            <MoreVert />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <Box className={classes.paginationContainer}>
                                    <TablePagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={parametrosFiltrados.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={(_, newPage) => setPage(newPage)}
                                        onRowsPerPageChange={e => {
                                            setRowsPerPage(+e.target.value)
                                            setPage(0)
                                        }}
                                        labelRowsPerPage="Itens por página"
                                        style={{ paddingLeft: "50px" }}
                                    />
                                </Box>
                            </Paper>
                        )
                    ) : (
                        <Box className={classes.emptyState}>
                            <Settings style={{ fontSize: 80, marginBottom: 16 }} />
                            <Typography variant="h6">Nenhum parâmetro encontrado</Typography>
                            <Typography variant="body2">
                                {busca
                                    ? "Tente ajustar sua busca"
                                    : "Comece criando seu primeiro parâmetro"}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </div>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                keepMounted
            >
                <MenuItem onClick={() => abrirDialogEditar(selectedRow)}>
                    <Edit style={{ marginRight: 8 }} />
                    Editar
                </MenuItem>
                <MenuItem onClick={() => excluir(selectedRow)}>
                    <Delete style={{ marginRight: 8 }} />
                    Excluir
                </MenuItem>
            </Menu>

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="sm"
                fullWidth
                fullScreen={isMobile}
                PaperProps={{ style: { borderRadius: isMobile ? 0 : 20 } }}
            >
                <DialogTitle>{editando ? "Editar Parâmetro" : "Novo Parâmetro"}</DialogTitle>
                <DialogContent className={classes.dialogContent}>
                    <TextField
                        fullWidth
                        label="Nome"
                        variant="outlined"
                        value={nome}
                        onChange={e => setNome(e.target.value)}
                        className={classes.formField}
                    />
                    <TextField
                        fullWidth
                        label="Valor"
                        variant="outlined"
                        value={valor}
                        onChange={e => setValor(e.target.value)}
                        className={classes.formField}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={publico}
                                onChange={e => setPublico(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Visível para o site"
                    />
                </DialogContent>
                <DialogActions
                    style={{
                        padding: 16,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 8,
                        flexDirection: isMobile ? "column" : "row",
                    }}
                >
                    <Button
                        onClick={() => setOpenDialog(false)}
                        style={{ borderRadius: 15, width: isMobile ? "100%" : "auto" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={salvar}
                        variant="contained"
                        style={{
                            borderRadius: 15,
                            backgroundColor: "#4caf50",
                            color: "white",
                            width: isMobile ? "100%" : "auto",
                        }}
                    >
                        {editando ? "Atualizar" : "Criar"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={openDialogExcluir} onClose={() => setOpenDialogExcluir(false)}>
                <DialogTitle>Confirmar exclusão do parâmetro</DialogTitle>
                <DialogActions>
                    <Button onClick={() => setOpenDialogExcluir(false)}>Cancelar</Button>
                    <Button onClick={confirmarExclusao} style={{ color: "#c62828" }}>
                        Excluir
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
